export default "__VITE_ASSET__CkKEt3nI__"